import Collapse from './Collapse'

export * from './Collapse'
export default Collapse
